import localeData from '../helpers/login.lang'
import {loginModes} from '../helpers/login.data'
import {isPasswordRequirementInvalid} from '../inputFields/passwordRequirements/passwordRequirements.helper'

const language = 'en'
const locale = localeData[language]
const {
  createNewPassword,
  forgotPassword,
  forgotPasswordEmailSent,
  normal,
  renewExpiredPassword,
  tfaCode,
  audit,
  forgottenPasswordLinkExpired
} = loginModes

// eslint-disable-next-line sonarjs/cognitive-complexity
export const buttonCaption = ({mode, isAuthPending, isSecretCodeSending, isFirstTime, hasProductionWarning}) => {
  switch (mode) {
    case normal:
      if (isAuthPending) {
        return locale.signingIn()
      }
      return locale.signIn()
    case tfaCode:
      if (isAuthPending) {
        return isSecretCodeSending ? locale.sendingNewSecretCode() : locale.signingIn()
      }
      return locale.verifyAndLogin()
    case forgotPassword:
    case forgotPasswordEmailSent:
      return isAuthPending ? locale.gettingANewPassword() : locale.getNewPassword()
    case createNewPassword:
      if (isFirstTime) {
        return isAuthPending ? locale.signingIn() : locale.letsGetStarted({hasProductionWarning})
      }
      return isAuthPending ? locale.signingIn() : locale.saveNewPassword()
    case renewExpiredPassword:
      return isAuthPending ? locale.signingIn() : locale.updateMyPassword()
    case audit:
      return locale.auditAction()
    case forgottenPasswordLinkExpired:
      return locale.getNewPassword()
    default:
      return ''
  }
}

const passwordPolicyInvalid = ({passwordPolicy, password, confirmPassword}) => !confirmPassword
      || password !== confirmPassword
      || Object.keys(passwordPolicy)
        .filter(key => key !== 'expireDays')
        .reduce(
          (invalid, policyName) =>
            invalid
                  || isPasswordRequirementInvalid({password, [policyName]: passwordPolicy[policyName]}),
          false
        )

export const isButtonDisabled = ({mode, codeSendMessage, isPasswordPolicyPending, isAuthInProgress, auditMessage, username, password, secretCode, passwordPolicy, confirmPassword}) => (mode === forgotPasswordEmailSent)
    || (mode === tfaCode && !/\d/.test(secretCode))
    || (mode === forgotPassword && !username)
    || (mode === createNewPassword && passwordPolicyInvalid({passwordPolicy, password, confirmPassword}))
    || (codeSendMessage === 'USER_PENALIZED')
    || isPasswordPolicyPending
    || isAuthInProgress
    || (mode === audit && (!auditMessage || !auditMessage.trim().length))
